import styled from"@emotion/styled";import{FlexLayout,mediaQuery,Link,Table}from"@wp/src/components/common";export const StyledPortfolioReviewTable=Table;export const PortfolioReviewTotalValue=styled.div`
  border: 1px solid ${props=>props.theme.colors.neutral300};
  ${mediaQuery({padding:["4px","6px","6px","8px","8px","8px"]})}
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  color: ${props=>props.theme.colors.neutral800};
`;export const PortfolioReviewName=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${props=>props.theme.colors.neutral500};
`;export const StyledPortfolioReviewTablesContainer=styled(FlexLayout)`
  max-height: calc(var(--vh, 1vh) * 80);
  overflow-y: auto;
`;export const StyledLink=styled(Link)`
  color: ${props=>props.theme.colors.red700};
`;